export type StoryblokPreviewSearch = Record<string, string | string[] | null | undefined>;

function firstString(value: unknown): string | undefined {
	if (typeof value === 'string') {
		return value;
	}

	if (Array.isArray(value)) {
		const first = value.find((item) => typeof item === 'string' && item !== '');
		return typeof first === 'string' ? first : undefined;
	}

	return undefined;
}

export function mergePreviewSearch(
	...parts: Array<StoryblokPreviewSearch | undefined>
): StoryblokPreviewSearch {
	const merged: StoryblokPreviewSearch = {};

	for (const part of parts) {
		if (!part) {
			continue;
		}

		for (const [key, value] of Object.entries(part)) {
			if (typeof value === 'string' && value !== '') {
				merged[key] = value;
			} else if (Array.isArray(value) && value.some((item) => typeof item === 'string' && item !== '')) {
				merged[key] = value;
			}
		}
	}

	return merged;
}

export function queryFromRequestUrl(url: string): Record<string, string> {
	const queryIndex = url.indexOf('?');
	if (queryIndex === -1) {
		return {};
	}

	const query: Record<string, string> = {};
	for (const [key, value] of new URLSearchParams(url.slice(queryIndex + 1))) {
		query[key] = value;
	}

	return query;
}

export type StoryblokPreviewParams = {
	version: 'draft' | 'published'
	from_release?: string
	_storyblok?: string
	'_storyblok_tk[space_id]'?: string
	'_storyblok_tk[timestamp]'?: string
	'_storyblok_tk[token]'?: string
};

export function storyblokPreviewParams(
	query: StoryblokPreviewSearch | undefined,
	options: {draftByDefault?: boolean} = {},
): StoryblokPreviewParams {
	const storyblok = firstString(query?._storyblok);
	// Storyblok sends _storyblok_release=0 when the story is not inside a release.
	const release = firstString(query?._storyblok_release);
	const fromRelease = release && release !== '0' ? release : undefined;
	const spaceId = firstString(query?.['_storyblok_tk[space_id]']);
	const timestamp = firstString(query?.['_storyblok_tk[timestamp]']);
	const token = firstString(query?.['_storyblok_tk[token]']);

	return {
		version: options.draftByDefault || storyblok ? 'draft' : 'published',
		...(fromRelease && {from_release: fromRelease}),
		...(storyblok && {_storyblok: storyblok}),
		...(spaceId && {'_storyblok_tk[space_id]': spaceId}),
		...(timestamp && {'_storyblok_tk[timestamp]': timestamp}),
		...(token && {'_storyblok_tk[token]': token}),
	};
}
